angular.module('unica_relator.relator_services')

.factory('RelatorCreateService', function ($http, getBaseApiURL) {

	var relatorCreateService = {};

	relatorCreateService.create = function (relatorData)
	{
		return $http({
			method: 'post',
			url: getBaseApiURL + '/relator/create',
			data: relatorData
		}).then(function(result) {

			if ( result ) {
				return result.data.relator;
			}

		});
	};

	return relatorCreateService;
});